module.exports = __webpack_public_path__ + "media/images/recommended-8f253e863fbfad679d262a43546681a3.svg";